export const RESYNCED_TABLES = new Set([
  "projects",
  "clients",
  "installations",
  "configurationLines",
  "sums",
  "vles",
  "flows",
  "sampleFlasks",
  "phases",
  "samples",
  "recordBooks",
  "acquisitionRecordBooks",
]);

export const recordKey = (table, uuid) => `${table}:${uuid}`;

export const pendingPageOf = ({ table, uuid, page, projectUuid }) =>
  table === "recordBooks"
    ? `/projects/${projectUuid}/recordbooks/${uuid}`
    : (page ?? `/projects/${projectUuid}`);

const uuidOf = (value) =>
  value && typeof value === "object" ? value.uuid : value;

export const referencesAny = (form, uuids) =>
  uuids.size > 0 &&
  Object.values(form ?? {}).some((value) =>
    Array.isArray(value)
      ? value.some((item) => uuids.has(uuidOf(item)))
      : uuids.has(uuidOf(value))
  );

export const isPendingRecord = (record) =>
  !!(record?.isCreatedOffline || record?.isUpdatedOffline);
